import React from 'react';
import { connect } from "react-redux";
import Icon from "../../../components/Icon";
import Certain from "../../../components/Operation/Certain";
import Factory from "../../../components/Operation/Factory";
import Id from "../../../components/Operation/Id";
import Locations from "../../../components/Operation/Locations";
import Logo from "../../../components/Operation/Logo";
import OperationStatus from "../../../components/Operation/OperationStatus";
import SiteUnit from "../../../components/Operation/SiteUnit";
import { AppState } from "../../../util/store/store";
import { OPERATION_TYPE, operationType } from "../../../util/varibles/constants";
import { getOperationStatus } from '../../../util/varibles/global';
import { IOperation } from "../../../util/varibles/interface";
import styles from './style.module.scss';

const mapStateToProps = (state: AppState) => {
    return {
        data: state.operationDetail.data,
    }
};

function view(data?: IOperation) {
    if (!data)
        return null;

    const { operation_type } = data.operation || {};
    switch (operation_type) {
        case OPERATION_TYPE.HARVEST: {
            return <div className={styles.locations}>
                <SiteUnit {...{ operation: data.operation }} />
                <span className='arrow-right' />
                <Factory {...{ operation: data.operation }} />
            </div>
        }
        case OPERATION_TYPE.TREATMENT:
        case OPERATION_TYPE.SERVICE: {
            return <div className={styles.locations}>
                <SiteUnit {...{ operation: data.operation }} />
            </div>
        }
        case OPERATION_TYPE.TRANSPORT: {
            const { source = { name: '' }, destination = { name: '' } } = data.operation;
            return <Locations className={styles.locations} locations={[source, destination]} />
        }
        case OPERATION_TYPE.EVENT: {
            const { pois } = data.operation;
            return <Locations className={styles.locations} locations={pois || []} separate={', '} />
        }
        default:
            return <></>
    }
}

interface IProps {
    data?: IOperation
}

const Title: React.FC<IProps> = ({ data }) => {
    if (!data)
        return null;

    const { operation_type, status, event_type, pauses = [] } = data.operation || {};

    if (operation_type === undefined)
        return null;

    const { icon } = operationType[operation_type] || {};
    const realStatus = getOperationStatus(status, pauses);

    return <div className={styles.title}>
        <Logo status={realStatus}>
            <Icon icon={icon!} dataAttribute={{ 'data-event-type': event_type }} />
        </Logo>
        <Id operation={data.operation} status={realStatus} />
        <OperationStatus status={realStatus} />
        <Certain {...{ operation: data.operation, status }} />
        {view(data)}
    </div>;
};
export default connect(mapStateToProps, {})(Title)

